const resourceMapMainQueryKey = "resource-maps";
export { resourceMapMainQueryKey };
